import { classNames } from 'primereact/utils';
import React from 'react';

// import { Container } from './styles';

type FieldMessageType = {
  name: string,
  error?: any
}

const FieldMessage: React.FC<FieldMessageType> = ({name, error}) => {
  return (
    <small 
      id={name + '-help'}
      style={{marginBottom: 10, marginTop:10}}
      className={classNames({ 'p-d-block p-error': error })}>
        {error?.message}
    </small>
  );
}

export default FieldMessage;